export const layouts = [
  {
    name: 'single-column',
    displayName: 'Single Column',
    classNames: ['single-column', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column'],
        },
      ],
    ],
  },
  {
    name: 'single-column-double-width',
    displayName: 'Single Column Double Width',
    classNames: ['single-column-double-width', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column'],
        },
      ],
    ],
  },
  {
    name: 'two-columns',
    displayName: 'Two Columns 50/50',
    classNames: ['two-columns', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column'],
        },
      ],
    ],
  },
  {
    name: 'three-columns',
    displayName: 'Three Columns 33/33/33',
    classNames: ['three-columns', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column'],
        },
        {
          name: 'column-3',
          classNames: ['layout-column'],
        },
      ],
    ],
  },
  {
    name: 'four-columns',
    displayName: 'Four Columns 25/25/25/25',
    classNames: ['four-columns', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column'],
        },
        {
          name: 'column-3',
          classNames: ['layout-column'],
        },
        {
          name: 'column-4',
          classNames: ['layout-column'],
        },
      ],
    ],
  },
  {
    name: 'sixty-forty',
    displayName: 'Two Columns 60/40',
    classNames: ['sixty-forty', 'layout-row'],
    rows: [
      [
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-60'],
        },
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-40'],
        },
      ],
    ],
  },
  {
    name: 'forty-sixty',
    displayName: 'Two Columns 40/60',
    classNames: ['forty-sixty', 'layout-row'],
    rows: [
      [
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-40'],
        },
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-60'],
        },
      ],
    ],
  },
  {
    name: 'overlap-right',
    displayName: 'Overlap Right',
    classNames: ['overlap-right', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'left-column'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'right-column'],
        },
      ],
    ],
  },
  {
    name: 'overlap-left',
    displayName: 'Overlap Left',
    classNames: ['overlap-left', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'left-column'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'right-column'],
        },
      ],
    ],
  },
  {
    name: 'thirty-seventy',
    displayName: 'Two Columns 30/70',
    classNames: ['thirty-seventy', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-30'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-70'],
        },
      ],
    ],
  },
  {
    name: 'seventy-30',
    displayName: 'Two Columns 70/30',
    classNames: ['thirty-seventy', 'layout-row'],
    rows: [
      [
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-70'],
        },
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-30'],
        },
      ],
    ],
  },
  {
    name: '25-50-25',
    displayName: 'Three Columns 25/50/25',
    classNames: ['quarter-half-quarter', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-25'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-50'],
        },
        {
          name: 'column-3',
          classNames: ['layout-column', 'col-25'],
        },
      ],
    ],
  },
  {
    name: '25-25-50',
    displayName: 'Three Columns 25/25/50',
    classNames: ['quarter-quarter-half', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-25'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-25'],
        },
        {
          name: 'column-3',
          classNames: ['layout-column', 'col-50'],
        },
      ],
    ],
  },
  {
    name: '40-20-20-20',
    displayName: 'Four Columns 40/20/20/20',
    classNames: ['forty-twenty-twenty-twenty', 'layout-row'],
    rows: [
      [
        {
          name: 'column-1',
          classNames: ['layout-column', 'col-40'],
        },
        {
          name: 'column-2',
          classNames: ['layout-column', 'col-20'],
        },
        {
          name: 'column-3',
          classNames: ['layout-column', 'col-20'],
        },
        {
          name: 'column-4',
          classNames: ['layout-column', 'col-20'],
        },
      ],
    ],
  },
]
